import styled from 'styled-components';

export const ImportContactsRoot = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: 100%;
`;
